 export const pictures =[ {
     name: 'messi',
     image:'/image/messi.png'

 },
  {
     name: 'baby',
     image:'/image/baby.png'

 },
 {
     name: 'baby2',
     image:'/image/baby2.png'

 },
 {
     name: 'mane',
     image:'/image/mane.png'

 },
 
]
export const Offer1 =
{
    name: 'mane',
    image: '/image2/softcopy.jpg'
    
};
 

export const Offer2 =
{
    name: 'baby2',
    image: '/image2/process.png'

};

export const Offer3 =
{
    name: 'baby2',
    image: '/image/baby.png'

};

export const howItWork = [
    {
    info:'we offer both selling of art works, editing and framing'
    },
    {
    info:' click on market place to buy any art work of your choice at an affordable price.'
},
    {
        info:"check on our art roll to make your choice then send us a message. we are available 24/7"
    }
]

export const Image = {
    img:'/image/kcee.jpg'
}
 export const ProductImage =[ {
     name: 'messi',
     image:'/image/messi.png'

 },
  {
     name: 'baby',
     image:'/image/baby.png'

 },
 {
     name: 'baby2',
     image:'/image/baby2.png'

 },
 {
     name: 'lady',
     image:'/image/lady.png'

 },
 {
     name: 'lady1',
     image:'/image/lady1.png'

 },
 {
     name: 'lady2',
     image:'/image/lady2.png'

 },
 {
     name: 'lady3',
     image:'/image/lady3.png'

 },
 {
     name: 'lady4',
     image:'/image/lady4.png'

 },
 {
     name: 'mane',
     image:'/image/mane.png'

 },
]

export const TestimoniesDetails = [
{
     descrip: 'i was amazed when i saw my replicate in a  frame.',
     image:'/image/test1.jpg'

 },
{
     descrip: 'i wonder who it would be if not kenneth art,the surest plug in artwork.',
     image:'/image/test2.jpg'

 },
]